import React from 'react';
import Section from '@components/Section';

export default function Education({ contact, underline = true }) {
  if (!contact.educations || contact.educations.length === 0) {
    return null;
  }

  return (
    <Section>
      <Section.Title underline={underline}>Education</Section.Title>
      {contact.educations.map((education, i) => (
        <div key={i}>
          <div className="title">{education.name}</div>
          {education.degree}
        </div>
      ))}
    </Section>
  );
}
